module.exports = __webpack_public_path__ + "static/media/sn.995ba865.svg";